export const mattressData = [
  {
    type: "product",
    prototype: "matras_two",
    id: "one-person-mattress",
    data: [
      {
        id: "option-lengte",
        type: "option",
        selected: "200 cm"
      },
      {
        id: "option-breedte",
        type: "option",
        selected: "70 cm"
      }
    ]
  },
  {
    type: "product",
    prototype: "matras_two",
    id: "two-one-person-mattresses",
    data: [
      {
        id: "option-lengte",
        type: "option",
        selected: "200 cm"
      },
      {
        id: "option-breedte",
        type: "option",
        selected: "70 cm"
      },
      {
        id: "option-matras-aantal",
        type: "option",
        selected: "twee"
      }
    ]
  },
  {
    type: "product",
    prototype: "matras_two",
    id: "two-person-mattress",
    data: [
      {
        id: "option-lengte",
        type: "option",
        selected: "200 cm"
      },
      {
        id: "option-breedte",
        type: "option",
        selected: "140 cm"
      }
    ]
  },
  {
    type: "product",
    prototype: "matras_elite",
    id: "one-person-mattress",
    data: [
      {
        id: "option-lengte",
        type: "option",
        selected: "200 cm"
      },
      {
        id: "option-breedte",
        type: "option",
        selected: "70 cm"
      }
    ]
  },
  {
    type: "product",
    prototype: "matras_elite",
    id: "two-one-person-mattresses",
    data: [
      {
        id: "option-lengte",
        type: "option",
        selected: "200 cm"
      },
      {
        id: "option-breedte",
        type: "option",
        selected: "70 cm"
      },
      {
        id: "option-matras-aantal",
        type: "option",
        selected: "twee"
      }
    ]
  },
  {
    type: "product",
    prototype: "matras_elite",
    id: "two-person-mattress",
    data: [
      {
        id: "option-lengte",
        type: "option",
        selected: "200 cm"
      },
      {
        id: "option-breedte",
        type: "option",
        selected: "140 cm"
      }
    ]
  },
  {
    type: "product",
    prototype: "matras_elysium",
    id: "one-person-mattress",
    data: [
      {
        id: "option-lengte",
        type: "option",
        selected: "200 cm"
      },
      {
        id: "option-breedte",
        type: "option",
        selected: "70 cm"
      }
    ]
  },
  {
    type: "product",
    prototype: "matras_elysium",
    id: "two-one-person-mattresses",
    data: [
      {
        id: "option-lengte",
        type: "option",
        selected: "200 cm"
      },
      {
        id: "option-breedte",
        type: "option",
        selected: "70 cm"
      },
      {
        id: "option-matras-aantal",
        type: "option",
        selected: "twee"
      }
    ]
  },
  {
    type: "product",
    prototype: "matras_elysium",
    id: "two-person-mattress",
    data: [
      {
        id: "option-lengte",
        type: "option",
        selected: "200 cm"
      },
      {
        id: "option-breedte",
        type: "option",
        selected: "140 cm"
      }
    ]
  },
  {
    type: "product",
    prototype: "matras_evolve",
    id: "one-person-mattress",
    data: [
      {
        id: "option-lengte",
        type: "option",
        selected: "200 cm"
      },
      {
        id: "option-breedte",
        type: "option",
        selected: "70 cm"
      }
    ]
  },
  {
    type: "product",
    prototype: "matras_evolve",
    id: "two-one-person-mattresses",
    data: [
      {
        id: "option-lengte",
        type: "option",
        selected: "200 cm"
      },
      {
        id: "option-breedte",
        type: "option",
        selected: "70 cm"
      },
      {
        id: "option-matras-aantal",
        type: "option",
        selected: "twee"
      }
    ]
  },
  {
    type: "product",
    prototype: "matras_evolve",
    id: "two-person-mattress",
    data: [
      {
        id: "option-lengte",
        type: "option",
        selected: "200 cm"
      },
      {
        id: "option-breedte",
        type: "option",
        selected: "140 cm"
      }
    ]
  },
  {
    type: "product",
    prototype: "matras_one",
    id: "one-person-mattress",
    data: [
      {
        id: "option-lengte",
        type: "option",
        selected: "200 cm"
      },
      {
        id: "option-breedte",
        type: "option",
        selected: "70 cm"
      }
    ]
  },
  {
    type: "product",
    prototype: "matras_one",
    id: "two-one-person-mattresses",
    data: [
      {
        id: "option-lengte",
        type: "option",
        selected: "200 cm"
      },
      {
        id: "option-breedte",
        type: "option",
        selected: "70 cm"
      },
      {
        id: "option-matras-aantal",
        type: "option",
        selected: "twee"
      }
    ]
  },
  {
    type: "product",
    prototype: "matras_one",
    id: "two-person-mattress",
    data: [
      {
        id: "option-lengte",
        type: "option",
        selected: "200 cm"
      },
      {
        id: "option-breedte",
        type: "option",
        selected: "140 cm"
      }
    ]
  }
]

